import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ language }) => {
  const texts = {
    en: {
      company: 'MobileHub4u',
      tagline: 'Streaming- und Download-Spiele für Salt und Sunrise.',
      quickLinks: 'Quick links',
      contact: 'Contact',
      address: 'GoMobee LTD, Singapore',
      email: 'gomobee.ch@silverlines.info',
      phone: '0041 44 581 61 61',
      privacy: 'Privacy',
      terms: 'Terms',
      impressum: 'Impressum',
      aboVerwaltung: 'Subscription management',
      contactLink: 'Contact',
      rights: 'All rights reserved.',
      serviceNote: 'MobileHub4u is an internet portal for streaming and download games (ch.nt.mobilehub4u.com). Enter your number and reply with JA (Salt and Sunrise). CHF 10 per week (2 SMS Salt, 1 SMS Sunrise). To cancel: send STOP TOP to 804 or contact 0041 44 581 61 61, gomobee.ch@silverlines.info. Domain & advertising rights: Adsaints B.V.',
    },
    de: {
      company: 'MobileHub4u',
      tagline: 'Streaming- und Download-Spiele für Salt und Sunrise.',
      quickLinks: 'Links',
      contact: 'Kontakt',
      address: 'GoMobee LTD, Singapore',
      email: 'gomobee.ch@silverlines.info',
      phone: '0041 44 581 61 61',
      privacy: 'Datenschutz',
      terms: 'AGB',
      impressum: 'Impressum',
      aboVerwaltung: 'Abo-Verwaltung',
      contactLink: 'Kontakt',
      rights: 'Alle Rechte vorbehalten.',
      serviceNote: 'MobileHub4u ist ein Internetportal für Streaming- und Download-Spiele (ch.nt.mobilehub4u.com). Nummer eingeben und mit JA antworten (Salt und Sunrise). CHF 10 pro Woche (2 SMS Salt, 1 SMS Sunrise). Kündigung: STOP TOP an 804 senden oder 0041 44 581 61 61, gomobee.ch@silverlines.info. Domain & Werberechte: Adsaints B.V.',
    },
  };

  const t = texts[language];

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-brand-400 mb-2">
              {t.company}
            </h3>
            <p className="text-slate-400 text-sm">{t.tagline}</p>
            <p className="text-slate-500 text-xs mt-4 leading-relaxed">
              {t.serviceNote}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-300 mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#section-2" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'Features' : 'Funktionen'}
                </a>
              </li>
              <li>
                <a href="#section-3" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'How it works' : 'So funktioniert’s'}
                </a>
              </li>
              <li>
                <a href="#section-4" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'Benefits' : 'Vorteile'}
                </a>
              </li>
              <li>
                <a href="/privacy.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.privacy}
                </a>
              </li>
              <li>
                <a href="/terms.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.terms}
                </a>
              </li>
              <li>
                <a href="/impressum.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.impressum}
                </a>
              </li>
              <li>
                <a href="/abo-verwaltung.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.aboVerwaltung}
                </a>
              </li>
              <li>
                <a href="/contact.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.contactLink || t.contact}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-300 mb-4">{t.contact}</h4>
            <div className="space-y-3 text-slate-400 text-sm">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-brand-500 flex-shrink-0" />
                <a href={`mailto:${t.email}`} className="hover:text-brand-400">
                  {t.email}
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-brand-500 flex-shrink-0" />
                <a href={`tel:${t.phone}`} className="hover:text-brand-400">
                  {t.phone}
                </a>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-brand-500 flex-shrink-0 mt-0.5" />
                <span>{t.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {t.company}. {t.rights}
          </p>
          <div className="flex gap-6">
            <a href="/privacy.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.privacy}
            </a>
            <a href="/terms.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.terms}
            </a>
            <a href="/impressum.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.impressum}
            </a>
            <a href="/abo-verwaltung.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.aboVerwaltung}
            </a>
            <a href="/contact.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.contactLink || t.contact}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
